module.exports = __webpack_public_path__ + "img/HZ-P6012.1615db08.jpg";